export default {"src":"/_next/static/media/logo.3bc44363.svg","height":103,"width":160,"blurWidth":0,"blurHeight":0};